export const calcTestScore = (testQuestions) => {
    let nbrCorrect = 0;
    for (let i=0; i<testQuestions.length; i++){
        let question = testQuestions[i];
        let totalRightAnswers = 0;
        let nbrCorrectAnswers = 0;
        let nbrIncorrectAnswers = 0;
        for (let j=0; j<question.answerList.length; j++){
            let answer = question.answerList[j];
            if (answer.checked === answer.correct && answer.correct === true){
                nbrCorrectAnswers += 1;
            }else{
                if (answer.checked === true){
                    nbrIncorrectAnswers += 1;
                }
            }
            if (answer.correct === true){
                totalRightAnswers += 1;
            }
        }
        let nbrCorrectCheckMarks = 0;
        if (nbrCorrectAnswers >= nbrIncorrectAnswers){
            nbrCorrectCheckMarks = nbrCorrectAnswers - nbrIncorrectAnswers;
        }
        const pctCorrect = +(nbrCorrectCheckMarks / totalRightAnswers);
        nbrCorrect += +pctCorrect.toFixed(2);
        testQuestions[i] = {...testQuestions[i], answerCorrectPct: pctCorrect};
    }
    const pctCorrect = +((nbrCorrect / testQuestions.length) * 100).toFixed(2);  
    const returnObj = {nbrCorrect: nbrCorrect, pctCorrect: pctCorrect};
    return returnObj;      
}
export default calcTestScore;